import { useState } from "react";
import { Select, Button, Flex } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useExportTranslations } from "../../api/translations";

function ExportTranslations() {
  const [format, setFormat] = useState("csv");

  const { mutate, isPending } = useExportTranslations();

  const handleExport = () => {
    mutate(
      { format },
      {
        onSuccess: (data) => {
          modals.closeAll();
        },
      }
    );
  };

  return (
    <Flex direction="column" gap="md">
      <Select
        label="Export Format"
        value={format}
        onChange={setFormat}
        data={[
          { value: "csv", label: "CSV" },
          { value: "xlsx", label: "Excel (XLSX)" },
        ]}
        allowDeselect={false}
      />
      <Button onClick={handleExport} loading={isPending} fullWidth>
        Export Translations
      </Button>
    </Flex>
  );
}

export function openExportModal() {
  return modals.open({
    title: "Export Translations",
    children: <ExportTranslations />,
    size: "sm",
    transitionProps: { transition: "fade", duration: 300 },
  });
}

export default ExportTranslations;
